// extracted by mini-css-extract-plugin
export default {"button":"ThumbsUpButton_button__Lc36k"};